import axios from "axios";
import {
    supportTicketDashboardApi,
    supportTicketTimelineGetApi,
    supportTicketCRUDApi,
    supportTicketTimelineCRUDApi,
    supportTicketAssignableUsersApi,
    supportTicketUserConfirmedOrdersApi,
} from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getSupportTicketsDashboard = async (query = "") => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(supportTicketDashboardApi + query, config);
    return response;
};

export const getSupportTicketsTimeline = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(supportTicketTimelineGetApi + query, config);
    return response;
};

export const supportTicketPost = async (data) => {
    const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
    const config = {
        headers: {
            ...(isFormData ? {} : { "Content-Type": "application/json" }),
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(supportTicketCRUDApi, data, config);
    return response;
};

export const supportTicketPatch = async (id, data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(supportTicketCRUDApi + id + "/", data, config);
    return response;
};

export const supportTicketTimelinePost = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(supportTicketTimelineCRUDApi, data, config);
    return response;
};

export const searchSupportAssignableUsers = async (search = "") => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const params = new URLSearchParams();
    ["staff", "admin", "manufacturer"].forEach((role) => params.append("role", role));
    if (search) {
        params.append("search", search);
    }

    const response = await axios.get(`${supportTicketAssignableUsersApi}?${params.toString()}`, config);
    return response;
};

export const getSupportTicketUserConfirmedOrders = async (userId) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(
        `${supportTicketUserConfirmedOrdersApi}?user_id=${encodeURIComponent(userId || "")}`,
        config
    );
    return response;
};
